export default (() => {
    const eventBuffers = Array.from(document.querySelectorAll('.js-no-bubble'));
    eventBuffers.forEach((el) => {
        el.addEventListener('click', (e) => e.stopPropagation());
    });
})();
